const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:1337' : 'https://mapchat-server.herokuapp.com';

export async function listLogEntries() {
    const response = await fetch(`${API_URL}/api/logs`);
    return response.json();
};

export async function createLogEntries(entry) {
    const response = await fetch(`${API_URL}/api/logs`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(entry),
    });
    let json;
    if (response.headers.get('content-type').includes('text/html')) {
        const message = await response.text();
        json = {
            message,
        };
    } else {
        json = await response.json();
    }
    if (response.ok) {
        return json;
    }
    const error = new Error(json.message);
    error.response = json;
    throw error;
};